import LocaleContext from "./LocaleContext";

const LocaleConsumer = LocaleContext.Consumer ;

export default LocaleConsumer ;